import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase/config'

/**
 * OAuth callback for LinkedIn. LinkedIn redirects here with ?code=...
 * We exchange the code for an access token, then redirect to LinkedIn Posts.
 */
const LinkedInCallback = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState('Exchanging code…')
  const [error, setError] = useState(null)

  useEffect(() => {
    const code = searchParams.get('code')
    if (!code) {
      setError('No authorization code in URL.')
      setStatus('Error')
      return
    }

    const redirectUri = `${window.location.origin}/linkedin-posts/callback`

    const exchange = async () => {
      try {
        const exchangeLinkedInAuthCode = httpsCallable(functions, 'exchangeLinkedInAuthCode')
        const result = await exchangeLinkedInAuthCode({ code, redirectUri })
        if (result.data?.success) {
          setStatus('Success!')
          navigate('/linkedin-posts?linkedin=success', { replace: true })
        } else {
          setError(result.data?.message || 'Exchange failed.')
          setStatus('Error')
        }
      } catch (err) {
        console.error('LinkedIn callback exchange error:', err)
        setError(err.message || 'Failed to complete authorization.')
        setStatus('Error')
      }
    }

    exchange()
  }, [searchParams, navigate])

  if (error) {
    return (
      <div style={{ padding: '2rem', maxWidth: '400px', margin: '0 auto', textAlign: 'center' }}>
        <p style={{ color: 'var(--error, #dc2626)', marginBottom: '1rem' }}>{error}</p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate('/linkedin-posts', { replace: true })}
        >
          Back to LinkedIn Posts
        </button>
      </div>
    )
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>{status}</p>
      <div className="loading-container"><div className="spinner" /></div>
    </div>
  )
}

export default LinkedInCallback
